__webpack_require__.p = "https://v2-form.apps.qorcommerce.io/";